<template>
  <el-form-item v-if="roles && roles.length > 0" label="Role" prop="role_id">
    <el-select-v2 :disabled="disableSelection" v-model="roleId" placeholder="Select Role" :options="roles" style="width: 100%"
      @change="$emit('selected-role-id', roleId)" />
  </el-form-item>
</template>

<script>
import { ref, watch } from "vue";
import store from "@/store";
import Constants from "@/helpers/constants";

export default {
  name: "RoleDropdownV2",
  props: {
    selected: {
      type: Number,
      default: -1,
    },
    isCreateMode: {
      type: Boolean,
      default: true,
    },
    selectedUser: {
      type: Object,
      default: null,
    },
  },
  emits: ["selected-role-id"],
  setup(props) {
    let roleId = ref(props.selected);
    if (roleId.value == -1) {
      roleId.value = "";
    }

    watch(
      () => props.selected,
      (current) => {
        if (current == -1) roleId.value = "";
        else roleId.value = current;
      }
    );
    return { roleId };
  },
  data() {
    return {
      roles: [],
      disableSelection: false,
    };
  },
  created() {
    let loggedInUser = this.$store.getters["auth/getLoggedInUser"]();

    store
      .dispatch("list/getRoles", { sort: "name", order: "asc" })
      .then((res) => {
        let rolesList = [];
        if (res.data && res.data.length > 0) {
          for (let data of res.data) {
             rolesList.push({ value: data.role_id, label: data.name })
          }
        }
        this.roles = rolesList;
        // If the user is a platoon commander, filter the roles
        // to only show the ones that are available to them
        if(loggedInUser.role && loggedInUser.role.role_id == Constants.ROLES.PLATOON_COMMANDER) {
          if(!this.isCreateMode && this.selectedUser && this.selectedUser.role_id == Constants.ROLES.PLATOON_COMMANDER) {
            this.roles = this.roles.filter(role => !Constants.CMNDR_EDT_RSTRCTD_ROLES.includes(role.value));
          } else {
            this.roles = this.roles.filter(role => !Constants.CMNDR_RSTRCTD_ROLES.includes(role.value));
          }
        }

        if(loggedInUser.role && loggedInUser.role.role_id == Constants.ROLES.USER_MANAGER) {
          if(!this.isCreateMode && this.selectedUser && this.selectedUser.role_id == Constants.ROLES.USER_MANAGER) {
            this.roles = this.roles.filter(role => !Constants.USR_MNGR_EDT_RSTRCTD_ROLES.includes(role.value));
          } else {
            this.roles = this.roles.filter(role => !Constants.USR_MNGR_RSTRCTD_ROLES.includes(role.value));
          }
        }

        if(!this.isCreateMode && this.selectedUser && 
          (this.selectedUser.role_id == Constants.ROLES.USER_MANAGER || this.selectedUser.role_id == Constants.ROLES.PLATOON_COMMANDER)) {
          this.disableSelection = true;
        } else {
          this.disableSelection = false;
        }
      });
  },
};
</script>

<style></style>